module.exports = __webpack_public_path__ + "img/721.d1043d7a.png";